import { render } from "./IndexConfigCourses.vue?vue&type=template&id=08b84640"
import script from "./IndexConfigCourses.vue?vue&type=script&lang=js"
export * from "./IndexConfigCourses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__